import FieldElementFactory from "@particles/forms/components/FieldElementFactory";

type FormProps = {
  /** The action to perform when the form is submitted. */
  action: string | ((formData: FormData) => void | Promise<void>);
  /** The fields to display in the form. */
  fields: FormFields[];
  /** The errors to display in the form. */
  fieldErrors: Record<string, string>;
  /** The class name to apply to the form. */
  className?: string;
  /** Whether the form is submitting. */
  isSubmitting?: boolean;
};

/** The form component. */
const Form = ({
  action,
  fields,
  fieldErrors,
  className,
  isSubmitting,
}: FormProps): React.ReactElement => {
  return (
    <form
      action={action}
      noValidate
      className={className}
      data-testid="form-component"
    >
      {fields.map((field) => {
        return (
          <FieldElementFactory
            key={field.name}
            field={field}
            errorMessage={fieldErrors[field.name] || ""}
            isSubmitting={isSubmitting}
          />
        );
      })}
    </form>
  );
};

export default Form;
